<ng-container>

    <bw-action-article-legacy minHeight="0" [brightsideWebFb]="displayAnalytics.shown">
      <div id="displayFormHeaderAction" header-actions class="flex-row pointer">
        <bw-icon-legacy
          *ngIf="config.pageHideBackButton; else showBackButton"
          color="var(--secondary-text)"
          iconName="close"
          (click)="handleBackClick()"
        ></bw-icon-legacy>

        <ng-template #showBackButton>
          <ui-nav-exit-back
            *ngIf="!pageIsFullScreen"
            back-action-top
            [trackingDetail]="displayAnalytics.dismiss"
            [skipActionEmit]="!config.pageOnBackCtaPath"
            (exitActionHandler)="handleBackClick()"
          ></ui-nav-exit-back>
          <ui-nav-exit-back
            *ngIf="pageIsFullScreen"
            back-action-bottom
            [trackingDetail]="displayAnalytics.dismiss"
            [skipActionEmit]="!config.pageOnBackCtaPath"
            (exitActionHandler)="handleBackClick()"
          ></ui-nav-exit-back>
        </ng-template>
      </div>
      <div header-title>
        <typography-legacy title-medium class="mt-xs">{{ config.pageTitleKey || config.pageTitle | translate }}</typography-legacy>
      </div>
      <div content-section>
        <bw-paragraph-legacy>
          <span [innerHTML]="config.pageSubTitleKey || config.pageSubTitle | translate"></span>
        </bw-paragraph-legacy>
        <ng-container *ngFor="let item of config.pageContentArray">
          <typography-legacy text-medium-semibold>
              {{ item[config.pageContentArrayKey.title] | translate }}
          </typography-legacy>
          <bw-paragraph-legacy>
          <ul>
            <li *ngFor="let docs of item[config.pageContentArrayKey.listItems]">
              {{ docs | translate }}
            </li>
          </ul>
          </bw-paragraph-legacy>
        </ng-container>
      </div>

      <div footer-top>
        <ng-container *ngIf="config.pageConfirmCheckText && checkboxForm">
          <form [formGroup]="checkboxForm">
            <bw-checkbox-legacy
              required
              formControlName="controlConfirmCheckbox"
              [label]="config.pageConfirmCheckText | translate"
              [centerAlign]="true"
              (checkboxChanged)="checkboxForm.markAllAsTouched()"
            ></bw-checkbox-legacy>
          </form>
        </ng-container>
      </div>
      <div footer-actions class="flex-row row-reverse">
        <button
          *ngIf="config.pageCtaLabel || config.pageCtaLabelKey"
          bw-button-legacy
          [brightsideWebFb]="displayAnalytics.submit"
          [disabled]="config.pageConfirmCheckText && (!checkboxForm?.touched || !checkboxForm?.valid || !checkboxForm?.dirty)"
          (click)="handleCtaClick()"
        >
          {{ config.pageCtaLabelKey || config.pageCtaLabel | translate }}
        </button>
      </div>
    </bw-action-article-legacy>
</ng-container>

